import {SbBlokData, storyblokEditable, useStoryblokApi} from "@storyblok/react";
import {IFeatureItem} from "../../types/IFeatureItem";
import ButtonGroup from "../partials/ButtonGroup";
import {addSlashIfNotAbsoluteUrl} from "../../utils/Helpers";
import {richTextResolver} from "@storyblok/richtext";

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

interface IProps {
    blok: {
        container_padding: string,
        container_class: string,
        title: string, subtitle: string, items: Array<IFeatureItem>, buttons: Array<any>
    } & SbBlokData
}

export default function CardGrid(props: IProps) {
    const blok = props.blok;
    const buttons = <ButtonGroup buttons={props.blok.buttons ?? []}/>
    const { render } = richTextResolver()

    return (
        <div {...storyblokEditable(props.blok)}>
            <div className={classNames(
                blok.container_class ?? 'bg-warm-gray-50',
                blok.container_padding ?? 'py-12 '
            )}>

                {blok.title &&
                <div
                    className=" py-12 px-6 sm:py-12 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center "
                         data-aos={'fade-in'}
                    >
                        {blok.title &&
                            <p className={(props.blok.size || 'text-4xl sm:text-4xl') + " font-bold leading-snug text-gray-900"}>
                                {blok.title}
                            </p>}

                        {blok.subtitle && <p className="mt-6 text-lg leading-8 text-gray-600">
                            {blok.subtitle}
                        </p>}

                        {buttons}
                    </div>
                </div>}

                <div
                    className="mx-auto max-w-5xl divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0">

                    {blok.items.map((action, actionIdx) => (
                        <div
                            key={action.title}
                            {...storyblokEditable(action)}
                            className={classNames(
                                actionIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '',
                                actionIdx === 1 ? 'sm:rounded-tr-lg' : '',
                                actionIdx === blok.items.length - 2 ? 'sm:rounded-bl-lg' : '',
                                actionIdx === blok.items.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '',
                                'relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-amber-500',
                                action.link?.cached_url ? 'hover:bg-gray-200' : 'hover:bg-gray-200'
                            )}
                        >
                            <div>
            <span
                className={classNames(
                    action.background_color || 'bg-indigo-50', //action.iconBackground,
                    action.color || 'text-primary',
                    'rounded-lg inline-flex p-3 ring-4 ring-white'
                )}
            >
              <span
                  dangerouslySetInnerHTML={{
                      __html: (action.icon)
                  }}
              />
            </span>
                            </div>
                            <div className="mt-8">
                                <h3 className="text-base font-semibold leading-6 text-gray-900">
                                    {action.link?.cached_url &&
                                        <a href={addSlashIfNotAbsoluteUrl(action.link?.cached_url)}
                                           className="focus:outline-none">
                                            {/* Extend touch target to entire panel */}
                                            <span className="absolute inset-0" aria-hidden="true"/>
                                            {action.title}
                                        </a>
                                    }
                                    {!action.link?.cached_url &&
                                        <span className="focus:outline-none">
                                        {action.title}
                                    </span>
                                    }
                                </h3>
                                <div className="mt-2 text-gray-500">
                                    <div className=""
                                         dangerouslySetInnerHTML={{
                                             __html: render(action.subtitle) as string
                                         }}
                                    >
                                    </div>
                                </div>
                            </div>
                            {action.link?.cached_url !== '' &&
                                <span
                                    className="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
                                    aria-hidden="true"
                                >
            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path
                  d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/>
            </svg>
          </span>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
